'use strict';

const jq = require('jquery');
window.$ = window.jQuery = jq;

const processInclude = require('base/util');

processInclude(require('./common/common'));
$(() => {
    processInclude(require('base/components/spinner'));
    processInclude(require('./components'));
    processInclude(require('./experience'));
    // SFRA Components
    // processInclude(require('base/components/cookie'));
    // processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/customModal'));
    processInclude(require('./components/companyMissingInfo'));
    processInclude(require('base/components/clientSideValidation'));
    // processInclude(require('base/components/toolTip'));
    processInclude(require('./account/account'));
    processInclude(require('./account/registration'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./product/regularDeliveryToggle'));
    processInclude(require('./product/quickAddToCart'));
    processInclude(require('./newsletter/newsletter'));
    processInclude(require('./contact/contactUs'));
    processInclude(require('./analytics/listener'));
    processInclude(require('./components/countrySelectorModal'));
    processInclude(require('./unlimitail/unlimitail'));
    processInclude(require('./unlimitail/unlimitailMenu'));
});

window.Popper = (require('popper.js').default || require('popper.js'));

require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/tab.js');
require('bootstrap/js/src/tooltip.js');
require('bootstrap-select/js/bootstrap-select');
require('slick-carousel/slick/slick');
require('bootstrap/js/src/alert.js');